<template>

    <div v-if="packageAvailability" class="add-on-panel has-shadow bg-white mb-4 position-relative"
         v-bind:class="{'h-100' : isHorizontal}">

        <span class="add-on-price d-none d-xl-block" v-if="!isHorizontal && packageAvailability.availability.Amount">
            <span class="add-on-price-amount">
                &pound;{{priceFormatted(packageAvailability.availability.Amount)}}
            </span>/{{packageAvailability.content.PerText}}
        </span>
        <div class="row d-flex flex-column">
            <div class="col-xl-8"
                 v-bind:class="{'col-xl-24' : isHorizontal}">
                <div class="add-on-gallery">
                    <single-image-gallery v-bind:images="packageAvailability.content.Images"></single-image-gallery>
                </div>
            </div>
            <div class="col-xl-16 d-flex col-xl-24 flex-grow-1"
                 v-bind:class="{'col-xl-24' : isHorizontal}">
                <div class="row ">
                    <div class="col-xl-12 px-5 py-3 py-xl-5 position-relative"
                         v-bind:class="{'col-xl-24' : isHorizontal}">
                        <h3 class="add-on-title mb-0 mb-xl-3">{{packageAvailability.content.DisplayName}}</h3>
                        <div v-if="packageAvailability.availability.Amount">

                            <span class="add-on-price add-on-price-m d-xl-none" v-if="!isHorizontal">
                                <span class="add-on-price-amount">
                                    &pound;{{priceFormatted(packageAvailability.availability.Amount)}}
                                </span>/{{packageAvailability.content.PerText}}
                            </span>

                            <span class="add-on-price add-on-price-m " v-if="isHorizontal">
                                <span class="add-on-price-amount">
                                    &pound;{{priceFormatted(packageAvailability.availability.Amount)}}
                                </span>/{{packageAvailability.content.PerText}}
                            </span>
                        </div>
                        <div v-else-if="packageAvailability.content.PriceOverride">

                            <span class="add-on-price add-on-price-m d-xl-none" v-if="!isHorizontal">
                                <span class="add-on-price-amount">
                                    &pound;{{priceFormatted(packageAvailability.content.PriceOverride)}}
                                </span>/{{packageAvailability.content.PerText}}
                            </span>

                            <span class="add-on-price add-on-price-m " v-if="isHorizontal">
                                <span class="add-on-price-amount">
                                    &pound;{{priceFormatted(packageAvailability.content.PriceOverride)}}
                                </span>/{{packageAvailability.content.PerText}}
                            </span>
                        </div>
                        <div class="add-on-description" v-html="packageAvailability.content.LongDescription"></div>
                    </div>

                    <div class="col-xl-12 px-5 py-3 py-xl-5 pb-4 justify-content-end flex-column d-flex  "
                         v-bind:class="{'col-xl-24' : isHorizontal}">
                        <div class=" mt-5">
                            <div v-for="(leg, index) in allowedLegs" class="allowed-leg">



                                <div class="row"
                                     v-if="packageAvailability.content.IsGolf">



                                    <div v-if="hasPackage(leg, packageAvailability)">

                                        <label class="add-on-label">Room {{leg.leg}}</label>

                                        <div class="package-config">
                                            <div class="mb-2" v-for="(s, si) in legPackage(leg, packageAvailability).selections ">

                                                <strong>
                                                    {{formatDate(s.date)}}  &nbsp;-&nbsp;{{formatTime(s.selection.Time)}}
                                                </strong>
                                                <div>
                                                    &nbsp;-&nbsp; {{s.quantity}} {{s.quantity == 1 ? 'player' : 'players' }}
                                                </div>
                                            </div>

                                            <button class="package-config-reset"
                                                    v-on:click="removePackage(leg, packageAvailability)">
                                                Reset
                                            </button>

                                        </div>

                                    </div>

                                    <button v-else
                                            class="btn btn--slate-blue btn--block btn--add"
                                            v-on:click="onAddGolf(leg, packageAvailability)">

                                        <span>Add for room {{leg.leg}}</span>
                                    </button>


                                </div>




                                <div class="row"
                                     v-else-if="packageAvailability.content.Restaurant">


                                    <div v-if="hasPackage(leg, packageAvailability)">

                                        <label class="add-on-label">Room {{leg.leg}}</label>

                                        <div class="package-config">
                                            <div class="mb-2" v-for="(s, si) in legPackage(leg, packageAvailability).selections ">

                                                <strong>

                                                    {{formatDate(s.date)}}  &nbsp;-&nbsp;{{formatTime(s.selection)}}
                                                </strong>
                                                <div>
                                                    &nbsp;-&nbsp; {{s.quantity}} {{s.quantity == 1 ? 'guest' : 'guests' }}
                                                </div>
                                            </div>

                                            <button class="package-config-reset"
                                                    v-on:click="removePackage(leg, packageAvailability)">
                                                Reset
                                            </button>

                                        </div>

                                    </div>



                                    <button v-else class="btn btn--slate-blue btn--block btn--add"
                                            v-on:click="onAddDining(leg, packageAvailability )">
                                        <span>Book a table for room {{leg.leg}}</span>
                                    </button>
                                </div>



                                <div class="row"
                                     v-else-if="packageAvailability.content.IsSpaTreatments">


                                    <div v-if="hasPackage(leg, packageAvailability)">

                                        <label class="add-on-label">Room {{leg.leg}}</label>

                                        <div class="package-config">
                                            <div class="mb-2" v-for="(s, si) in legPackage(leg, packageAvailability).selections ">

                                                <strong>

                                                    {{formatDate(s.selection.selection.StartTime)}}  &nbsp;-&nbsp;{{formatTime(s.selection.selection.StartTime)}}
                                                </strong>
                                                <div>


                                                    {{leg.guests[s.selection.guestIndex].firstName}} - {{s.selection.treatment.DisplayName}}

                                                </div>
                                            </div>

                                            <button class="package-config-reset"
                                                    v-on:click="removePackage(leg, packageAvailability)">
                                                Reset
                                            </button>

                                        </div>

                                    </div>



                                    <button v-else class="btn btn--slate-blue btn--block btn--add"
                                            v-on:click="onAddSpa(leg, packageAvailability )">
                                        <span>Book your treatments for room {{leg.leg}}</span>
                                    </button>
                                </div>








                                <div class="row"
                                     v-else-if="packageAvailability.content.IsMudTreatment">


                                    <div v-if="hasPackage(leg, packageAvailability)">

                                        <label class="add-on-label">Room {{leg.leg}}</label>

                                        <div class="package-config">
                                            <div class="mb-2" v-for="(s, si) in legPackage(leg, packageAvailability).selections ">

                                                <strong>

                                                    {{formatDate(s.selection.StartDateTime)}}  &nbsp;-&nbsp;{{formatTime(s.selection.StartDateTime)}}
                                                </strong>
                                                <div>
                                                    {{getGuests(s,leg)}}


                                                </div>
                                            </div>

                                            <button class="package-config-reset"
                                                    v-on:click="removePackage(leg, packageAvailability)">
                                                Reset
                                            </button>

                                        </div>

                                    </div>



                                    <button v-else class="btn btn--slate-blue btn--block btn--add"
                                            v-on:click="onAddMud(leg, packageAvailability )">
                                        <span>Book your experience for room {{leg.leg}}</span>
                                    </button>
                                </div>




                                <div class="row"
                                     v-else-if="packageAvailability.content.IsSpaGarden">


                                    <div v-if="hasPackage(leg, packageAvailability)">

                                        <label class="add-on-label">Room {{leg.leg}}</label>

                                        <div class="package-config">
                                            <div class="mb-2" v-for="(s, si) in legPackage(leg, packageAvailability).selections ">

                                                <strong>

                                                    {{formatDate(s.selection.StartDateTime)}}  &nbsp;-&nbsp;{{formatTime(s.selection.StartDateTime)}}
                                                </strong>
                                                <div>
                                                    {{getGuests(s,leg)}}


                                                </div>
                                            </div>

                                            <button class="package-config-reset"
                                                    v-on:click="removePackage(leg, packageAvailability)">
                                                Reset
                                            </button>

                                        </div>

                                    </div>



                                    <button v-else class="btn btn--slate-blue btn--block btn--add"
                                            v-on:click="onAddGarden(leg, packageAvailability )">
                                        <span>Book your experience for room {{leg.leg}}</span>
                                    </button>
                                </div>
















                                <div v-else>

                                    <div class="row mb-3 mb-md-0"
                                         v-if="packageAvailability.availability.PriceCalculationMode == 0">
                                        <div class="col-24 col-md-12">
                                            <label class="flat-rate-toggle">
                                                <input type="checkbox"
                                                       v-bind:checked="hasPackage(leg, packageAvailability)"
                                                       v-on:click="togglePackage(packageAvailability, leg)" />
                                                <span>
                                                    Add to Room {{leg.leg}}
                                                </span>
                                            </label>
                                        </div>
                                        <div v-if="hasPackage(leg, packageAvailability)"
                                             class="col-24 col-md-12 d-flex justify-content-end">
                                            <!--<spinner v-on:value-change="(value) => setQuantity(packageAvailability, value, leg)"
                                            v-bind:initial="0"
                                            v-bind:min="1"
                                            v-bind:max="6"
                                            v-bind:label="'Qty:'"></spinner>-->


                                            <div class="spinner d-flex flex-row">
                                                <label class="d-block d-md-none">
                                                    Quantity:
                                                </label>
                                                <div class="selector">
                                                    <button class="btn-selector" v-on:click="onDecrement(leg, packageAvailability)">-</button>
                                                    <span class="value">{{getLetPackageCount(leg, packageAvailability)}}</span>
                                                    <button class="btn-selector" v-on:click="onIncrement(leg, packageAvailability)">+</button>
                                                </div>

                                            </div>










                                        </div>
                                    </div>




                                    <div v-if="packageAvailability.availability.PriceCalculationMode != 0">
                                        <label class="add-on-label">Room {{leg.leg}}</label>

                                        <div>

                                            <button class="btn btn--slate-blue btn--block"
                                                    v-bind:class="getButtonClass(leg, packageAvailability)"
                                                    v-on:click="togglePackage(packageAvailability, leg)">


                                                <span>
                                                    {{hasPackage(packageAvailability, leg) ? 'Remove' : 'Add'}} For Room {{leg.leg}}
                                                </span>
                                            </button>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <booking-modal v-if="modalRestaurantVisible" v-on:close="modalRestaurantVisible = false">
        <template v-slot:logo>
            <img src="/Assets/img/booking/spa_package-gold.svg" />
        </template>
        <template v-slot:body>
            <package-dinner-availability v-bind:activePackage="activePackage"
                                         v-bind:activeLeg="activeLeg"></package-dinner-availability>

        </template>
    </booking-modal>

    <div class="modal-full">
        <booking-modal v-if="modalGolfVisible" v-on:close="modalGolfVisible = false">
            <template v-slot:logo>
                <img src="/Assets/img/booking/flag-gold.svg" />
            </template>
            <template v-slot:body>
                <div>
                    <package-golf-availability v-bind:activePackage="activePackage"
                                               v-bind:activeLeg="activeLeg"></package-golf-availability>
                </div>
            </template>

        </booking-modal>
    </div>

    <div class="modal-full">
        <booking-modal v-if="modalSpaVisible" v-on:close="modalSpaVisible = false">
            <template v-slot:logo>
                <img src="/Assets/img/booking/spa_package-gold.svg" />
            </template>
            <template v-slot:body>
                <package-spa-availability v-bind:activePackage="activePackage"
                                          v-bind:activeLeg="activeLeg"></package-spa-availability>

            </template>

        </booking-modal>
    </div>



    <div class="modal-full">
        <booking-modal v-if="modalMudVisible" v-on:close="modalMudVisible = false">
            <template v-slot:logo>
                <img src="/Assets/img/booking/spa_package-gold.svg" />
            </template>
            <template v-slot:body>

                <package-spa-mud-availability v-bind:activePackage="activePackage"
                                              v-bind:activeLeg="activeLeg"></package-spa-mud-availability>

            </template>

        </booking-modal>
    </div>


    <div class="modal-full">
        <booking-modal v-if="modalGardenVisible" v-on:close="modalGardenVisible = false">
            <template v-slot:logo>
                <img src="/Assets/img/booking/spa_package-gold.svg" />
            </template>
            <template v-slot:body>

                <package-spa-garden-availability v-bind:activePackage="activePackage"
                                                 v-bind:activeLeg="activeLeg"></package-spa-garden-availability>

            </template>

        </booking-modal>
    </div>

</template>

<script>

    import SingleImageGallery from '@/shared/components/SingleImageGallery.vue';
    import Spinner from '@/shared/components/Spinner.vue';

    import BookingModal from './BookingModal.vue';
    import PackageDinnerAvailability from './PackageDinnerAvailability.vue';
    import PackageGolfAvailability from './PackageGolfAvailability.vue';
    import PackageSpaAvailability from './PackageSpaAvailability.vue';
    import PackageSpaMudAvailability from './PackageSpaMudAvailability.vue';
    import PackageSpaGardenAvailability from './PackageSpaGardenAvailability.vue';

    import { store } from '../store/index';

    export default {
        name: 'PackagePanel',
        props: {
            leg: String,
            availability: Object,
            isHorizontal: Boolean
        },
        computed: {
            session() {
                return store.getters.session
            },
            price() {
                return 0;
            },
            booking() {
                return store.getters.booking;
            },
            allowedLegs() {
                let result = [];
                let booking = this.booking;
                for (let li in booking.legs) {

                    let leg = booking.legs[li];
                    if (leg.rate.rateGroupRate != undefined && leg.rate.rateGroupRate.AllowedAddOnPackages != null) {
                        if (leg.rate.rateGroupRate.AllowedAddOnPackages.includes(this.packageAvailability.availability.Code)) {
                    
                            if (this.packageAvailability.content.MinOccupancy == null || this.packageAvailability.content.MinOccupancy <= leg.guestQuota.Adults) {


                                result.push(leg)
                            }
                        }
                    }
                }
                return result;
            }
        },
        components: {
            BookingModal,
            SingleImageGallery,
            Spinner,
            PackageDinnerAvailability,
            PackageGolfAvailability,
            PackageSpaAvailability,
            PackageSpaMudAvailability,
            PackageSpaGardenAvailability
        },
        data() {
            return {
                modalRestaurantVisible: false,
                modalGolfVisible: false,
                modalSpaVisible: false,
                modalMudVisible: false,
                modalGardenVisible: false,
                activeLeg: null,
                //activeRestaurant: null,
                activePackage: null,
                packageAvailability: null,
                flatRateSelected: false,
            }
        },
        mounted() {
            this.packageAvailability = this.availability;
        },
        methods: {
            hasPackage(leg, pckge) {

                return this.legPackage(leg, pckge) != null;
            },
            legPackage(leg, pckge) {
                if (leg.packages != undefined && leg.packages != null) {

                    let pc = leg.packages.find(p => p.item.availability.Code === pckge.availability.Code);

                    if (pc != null) {
                        return pc;
                    }
                }

                return null;
            },

            onTrackChildExtra(value) {
                console.log(value) // someValue
            },


            onAddGolf(leg, pckge) {
                this.activeLeg = leg;
                this.activePackage = pckge;
                this.modalGolfVisible = true;
            },
            onAddDining(leg, pckge) {
                this.activeLeg = leg;

                this.activePackage = pckge;

                this.modalRestaurantVisible = true;
            },
            onAddSpa(leg, pckge) {
                this.activeLeg = leg;
                this.activePackage = pckge;

                this.modalSpaVisible = true;

            },

            onAddMud(leg, pckge) {
                this.activeLeg = leg;
                this.activePackage = pckge;

                this.modalMudVisible = true;

            },
            onAddGarden(leg, pckge) {
                this.activeLeg = leg;
                this.activePackage = pckge;

                this.modalGardenVisible = true;

            },

            totalGuests(leg) {
                return leg.guestQuota.Adults + leg.guestQuota.Children + leg.guestQuota.Infants;
            },


            removePackage(leg, item) {


    let legIndex = +(leg.leg) - 1;

                var quantity = this.booking.legs[legIndex]?.packages.find(p => p.item.content.PMSCode == item.availability.Code)?.quantity || 1;


                this.addRemoveAddOn(leg, false, item, quantity);

                //Want to get whats on teh the booking first
                //and just remove that quantity from GA
                //then continue....


                let payload = {
                    leg: leg.leg,
                    code: item.availability.Code
                };
                store.dispatch("removePackage", payload);
            },

            togglePackage(item, leg) {
              
                if (this.hasPackage(leg, item)) {
                    this.removePackage(leg, item)
                }
                else {

                    this.addRemoveAddOn(leg, true, item, item.quantity);

                    // Track an add with 1 on it...

                    let payload = {
                        item: item,
                        leg: leg.leg,
                        quantity: item.quantity
                    };
                    store.dispatch("selectPackage", payload);

                }
            },















            restaurantPackages(leg, item) {

                if (leg.packages != undefined && leg.packages != null) {
                    var p = leg.packages.find(p => p.availability.Code == item.availability.Code);
                    if (p != null) {
                        if (p.restaurantBookings !== undefined && p.restaurantBookings !== null && p.restaurantBookings.length) {
                            return p.restaurantBookings;
                        }
                    }


                }

                return [];
            },

            getButtonClass(leg, item) {

                if (this.hasPackage(item, leg)) {
                    return 'btn--remove';

                }
                return "btn--add";
            },

            priceFormatted(num) {
                if (num % 1 == 0) {
                    return num;
                }

                return num.toFixed(2);
            },
            restaurantName(input) {

                return input;
            },
            formatDate(input) {
                var date = moment(input);
                return date.format('dddd')
            },
            formatTime(input) {
                var date = moment(input);
                return date.format('HH:mm')
            },


            onIncrement(leg, pckge) {

                //should quantity be 1 or (existingPckge.quantity + 1)?
                this.addRemoveAddOn(leg, true, pckge, 1);

                let code = pckge.availability.Code;
                let existingPckge = leg.packages.find(x => x.item.availability.Code == code);


                if (existingPckge.quantity < 6) {
                    existingPckge.quantity = existingPckge.quantity + 1;

                    //Add a new item with 1 quantity on it
                    

                    this.setQuantity(pckge, existingPckge.quantity, leg);
                }


            },
            onDecrement(leg, pckge) {

                this.addRemoveAddOn(leg, false, pckge, 1);

                let code = pckge.availability.Code;
                let existingPckge = leg.packages.find(x => x.item.availability.Code == code);

                if (existingPckge.quantity > 0) {
                    existingPckge.quantity = existingPckge.quantity - 1;

                    //Remove item with 1 quantity on it


                    this.setQuantity(pckge, existingPckge.quantity, leg);
                }
            },
            getLetPackageCount(leg, pckge) {
                let code = pckge.availability.Code;
                let existingPckge = leg.packages.find(x => x.item.availability.Code == code);

                if (existingPckge.quantity == 0) {
                    existingPckge.quantity = 1;
                    this.setQuantity(pckge, existingPckge.quantity, leg);
                }
                return existingPckge.quantity;
            },


            setQuantity(packageAvailability, value, leg) {



                let payload = {
                    quantity: value,
                    item: packageAvailability,
                    leg: leg.leg
                };
                //      packageAvailability.quantity = value;
                store.dispatch("updatePackageQuantity", payload);
            },
            getGuests(s, leg) {
                let result = [];
                for (var si = 0; si < s.guestIndexes.length; si++) {
                    var guest = leg.guests[s.guestIndexes[si]];
                    result.push(guest.firstName);
                }


                return result.slice(0, -1).toString() + ' & ' + result[result.length - 1];



            },


            addRemoveAddOn(leg, add, addOn, quantity) {
                    // this needs leg added

             
                if (this.$gtm.enabled()) {

                    let item = null;
                    if (quantity != undefined) {
                        item = {
                            'item_id': addOn.content.PMSCode,
                            'item_name': addOn.content.DisplayName,
                            'item_list_name': 'Add On',
                            'price': addOn.availability.Amount,
                            'quantity' : quantity
                        };
                    }
                    else {
                        item = {
                            'item_id': addOn.content.PMSCode,
                            'item_name': addOn.content.DisplayName,
                            'item_list_name': 'Add On',
                            'price': addOn.availability.Amount,
                        };
                    }

                    window.dataLayer?.push({
                        'pageURL': '/stay/add-ons',
                        'event': add ? 'add_to_cart' : 'remove_from_cart',
                        'ecommerce': {
                            'items': [item]
                        }
                    });
                }
            }





        },
    }
</script>

<style>
    .add-on-panel {
        min-height: 344px;
    }


        .add-on-panel > .row {
            min-height: 344px;
            height: 100%;
        }


        .add-on-panel .spinner {
            flex-direction: row-reverse;
            height: 80%;
            border: none;
            top: 10%;
            position: relative;
            justify-content: space-between;
        }

            .add-on-panel .spinner label {
                font-size: 18px;
                margin-right: 10px;
                font-weight: 300;
            }

            .add-on-panel .spinner .selector {
                border: none;
                align-items: center;
                width: 105px;
            }

            .add-on-panel .spinner .btn-selector {
                border: solid 1px #eae5e3;
                height: 32px;
                width: 32px;
            }


        .add-on-panel .spinner {
            width: auto;
            display: flex;
            flex-direction: column;
        }



            .add-on-panel .spinner label {
                text-transform: none !important;
                margin-top: 10px;
                margin-bottom: 10px;
            }

            .add-on-panel .spinner .selector {
                display: flex;
                justify-content: space-between;
                padding: 5px;
                border: solid 1px #e4e5ea;
            }

                .add-on-panel .spinner .selector .btn-selector {
                    height: 100%;
                    background-color: transparent;
                    border: none;
                }



    .add-on-price {
        text-align: right;
        font-weight: 300;
        width: 100%;
        display: inline-block;
        margin-bottom: 20px;
        position: absolute;
        top: 40px;
        right: 40px;
    }

    .add-on-price-m {
        position: static;
        margin-bottom: 0px;
        left: 0;
        top: 0;
        text-align: left;
    }

    .add-on-price-amount {
        font-size: 24px;
        font-weight: bold;
    }

    .add-on-title {
        font-size: 24px;
    }

    .add-on-label {
        font-size: 14px;
        font-weight: bold;
    }

    .add-on-description {
        font-size: 14px;
    }



    .flat-rate-toggle {
        background: #eae5e3;
        padding: 15px;
        font-size: 14px;
        font-weight: bold;
        min-width: 205px;
        cursor: pointer;
        width: 100%;
        line-height: 22px;
        cursor: pointer;
    }

        .flat-rate-toggle input[type=checkbox],
        .flat-rate-toggle span {
            line-height: 22px;
            display: inline-block;
            vertical-align: baseline;
        }

        .flat-rate-toggle input[type=checkbox] {
            height: 22px;
            width: 22px;
            margin-right: 10px;
            top: 4px;
            position: relative;
        }

    .allowed-leg {
        margin-bottom: 15px;
    }

        .allowed-leg:last-of-type {
            margin-bottom: 0;
        }

    .btn {
        margin-bottom: 0 !important;
    }







    .package-config {
        padding: 20px;
        border-radius: 2px;
        background-color: #eae5e3;
        color: #333;
        font-size: 14px;
        font-family: Montserrat;
        position: relative;
    }


    .package-config-reset {
        text-indent: -9999px;
        position: absolute;
        top: 20px;
        right: 20px;
        border: none;
        height: 15px;
        width: 15px;
        background-size: 15px 15px;
        background-position: center center;
        background-repeat: no-repeat;
        background-image: url(/Assets/img/website/modal-close.svg);
        background-color: transparent;
    }
</style>